<div class="projects mb-4">
    <div class="card">
            <div class="card-header header-background">
                  <div class="row">
                      <div class="col-sm-3">
                          <h2>Plan de Mejora</h2>
                      </div>
                  </div>
            </div>
    

            <div>
                <app-plan-seguimiento [region]="region"></app-plan-seguimiento> 
            </div>
    </div>
  </div>